// Two entries can overlap (e2e walk 2026-10-31, navigation 6 organic): a tap
// that navigates (the organic room's "Draw a card" pushes /?reader=iam) starts
// a newer entry while the page's first entry is still finishing its
// start-session. The older one must not run on as if it were alone: its
// welcome took the newer entry's pending Ask and its landing put the organic
// room back. Each entry takes a turn; a session start remembers the turn it
// began in; once a newer entry has begun, the older turn is no longer current.
export function entryTurns () {
  let n = 0
  return {
    /** An entry begins: its turn. */
    begin () { n += 1; return n },
    /** The turn now (a session start takes it as it asks). */
    now () { return n },
    /** No newer entry since this turn? (No turn given: current.) */
    current (turn) { return turn == null || turn === n },
  }
}
